import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
/** Footer actions for the encounter flow: cancel/back and review/submit. */
export function EncounterFlowFooter(_ref) {
  var action = _ref.action,
    isReview = _ref.isReview,
    canReview = _ref.canReview,
    isSubmitting = _ref.isSubmitting,
    onBack = _ref.onBack,
    onCancel = _ref.onCancel,
    onReview = _ref.onReview,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isReview ? /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    "data-testid": "encounter-flow-back",
    onClick: onBack
  }, t("back", {
    defaultValue: "Back"
  })) : /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    "data-testid": "encounter-flow-cancel",
    onClick: onCancel
  }, t("cancel", {
    defaultValue: "Cancel"
  })), isReview ? /*#__PURE__*/React.createElement(Button, {
    "data-testid": "encounter-flow-submit",
    disabled: isSubmitting,
    onClick: onSubmit
  }, isSubmitting ? t("submitting", {
    defaultValue: "Submitting…"
  }) : action === "create" ? t("create_encounter", {
    defaultValue: "Create encounter"
  }) : t("submit", {
    defaultValue: "Submit"
  })) : /*#__PURE__*/React.createElement(Button, {
    "data-testid": "encounter-flow-review",
    disabled: !canReview,
    onClick: onReview
  }, action === "create" ? t("review_and_create", {
    defaultValue: "Review and create"
  }) : t("review", {
    defaultValue: "Review"
  })));
}